<template>
  <div>
    <swiper :type="4"></swiper>
    <product></product>
  </div>
</template>
<script>
import swiper from "./swiper";
import product from "./products/productseries";
export default {
  components: {
    swiper,
    product
  }
};
</script>

